// Single source of truth for the SMS opt-in consent language (spec: contact-phone-consent
// AC-2.2). The rendered checkbox label, the persisted ConsentAudit version, and the A2P
// registration evidence bundle all reference THIS text and version. Any edit to the copy
// MUST bump the version string (consent-v1 -> consent-v2) — the server env
// SMS_CONSENT_TEXT_VERSION is the authoritative persisted value and must be kept in step.

export const SMS_CONSENT_TEXT_VERSION = "consent-v1";

// Plain-text sentence; the trailing policy references are rendered as links by the form
// bootstrap (contactMain) using PRIVACY_PATH/TERMS_PATH below.
export const SMS_CONSENT_TEXT =
  "I agree to receive text messages from Evan Howell Properties about my inquiry and " +
  "scheduling my interview (up to 4 msgs/month). Msg & data rates may apply. Reply STOP " +
  "to opt out, HELP for help. Consent is not a condition of service. See our " +
  "Privacy Policy and Terms.";

export const PRIVACY_PATH = "/privacy.html";
export const TERMS_PATH = "/terms.html";
